module.exports = __webpack_public_path__ + "img/bxzj-logo.3121cf88.png";